module.exports = __webpack_public_path__ + "static/aloe-design-chair-e8e650760b7004912796a5cebe9cdc86.mp4";